const UnknownForm = () => {
    return (
    <div className="container">
        <div className="d-flex flex-column align-items-center">
            <div className="full-page-load">            
                    <div className="mr-auto text-center p-2">
                    <h6>Oh dear!</h6>
                    <h4>We can’t seem to find what you’re looking for. Let’s figure this out!</h4>
                        
                    <div className="mr-auto text-center p-2">
                        intoCareers partners with government agencies, schools, and organizations across the US. We customize this order form and ordering process to best support each region. 
                        Check with the folks who referred you here, or, if you do not know how to access the order form you need, please send us an email at <a href="mailto:CISHelp@uoregon.edu">CISHelp@uoregon.edu</a> and we would be happy to help!
                    </div>

                </div>
                
            </div>
        </div>  
    </div>      

    )
}

export { UnknownForm };